export const headerLayout = 2
export const mobileLayout = 1

// Forgotten password version - 1, 2
export const forgotPasswordVersion = 2

export const contactConfig = {
    phoneNumber: '+43 676 332 3987',
    mail: 'info@abamal.at',
}

$('body').addClass(`header-layout-${headerLayout}`)
$('body').addClass(`able-mobile-layout-${mobileLayout}`)
